import { constants } from "shared/constants";
import { format } from "date-fns";
import { Address } from "view360Card/models";

const locales = "pl-PL";

export function formatNumber(number: Number): string {
    const numberSplitted = number.toString().split(".");
    const numOfFractionDigits = numberSplitted.length === 2 ? numberSplitted[1].length : 0;
    const decimalDigits = +numberSplitted[0];

    const decimalDigitsAsLocal = decimalDigits
        .toLocaleString(locales, {
            maximumFractionDigits: numOfFractionDigits,
        })
        .replace(/\B(?=(\d{3})+(?!\d))/g, " ");

    let result = decimalDigitsAsLocal;
    if (numOfFractionDigits > 0) {
        result = `${decimalDigitsAsLocal},${numberSplitted[1]}`;
    }
    return result;
}

export function formatDate(date: Date | undefined): string | undefined {
    if (!date) {
        return undefined;
    }

    return format(date, constants.dateFormat);
}

export function formatDateYearOnly(date: Date | undefined): string | undefined {
    if (!date) {
        return undefined;
    }

    return format(date, constants.dateFormatYear);
}

export function formatDateTime(date: Date | undefined): string | undefined {
    if (!date) {
        return undefined;
    }

    return format(date, constants.dateTimeFormat);
}

export function joinIfHasValue(collection: (string | undefined)[], separator: string, noValue: string | undefined) {
    const toJoin: string[] = [];

    collection.forEach((i) => {
        if (i) {
            toJoin.push(i);
        }
    });

    if (toJoin.length === 0) {
        return noValue;
    }

    return toJoin.join(separator);
}

export function formatAddress(address: Address | undefined): string | undefined {
    if (!address) {
        return undefined;
    }

    if (!address.streetName) {
        return joinIfHasValue(
            [address.postalCode, address.city, `${address.streetNumber ?? constants.noValue}`],
            " ",
            undefined
        );
    }

    const apartmentNumber = address.apartmentNumber ? `/${address.apartmentNumber}` : "";

    return joinIfHasValue(
        [
            address.streetName,
            `${address.streetNumber ?? constants.noValue}${apartmentNumber},`,
            address.postalCode,
            address.city,
        ],
        " ",
        undefined
    );
}

export function formatPercentageNumber(
    number: number | undefined,
    noValue: string = constants.noValue,
    noValueIfZero: boolean = true,
    mulitplyByHundred: boolean = true
): string {
    if (number === undefined || number === null) {
        return noValue;
    }

    if (number === 0 && noValueIfZero) {
        return noValue;
    }

    const percentageNumber = mulitplyByHundred ? number * 100 : number;
    var asLocal = percentageNumber.toLocaleString("pl-PL", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });

    asLocal = asLocal.replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    return `${asLocal}%`;
}

export function formatNumberOrEmtpy(
    number: Number,
    isPercentage: boolean,
    noValue: string = constants.noValue
): string {
    if (number === undefined || number === null) {
        return noValue;
    }

    return `${formatNumber(number)}${isPercentage ? constants.percent : ""}`;
}

export const dateLocalizationStrings = {
    shortDays: ["nie", "pon", "wto", "śro", "czw", "pią", "sob"],
    days: ["niedziela", "poniedziałek", "wtorek", "środa", "czwartek", "piątek", "sobota"],
    months: [
        "styczeń",
        "luty",
        "marzec",
        "kwiecień",
        "maj",
        "czerwiec",
        "lipiec",
        "sierpień",
        "wrzesień",
        "październik",
        "listopad",
        "grudzień",
    ],
};
